function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "cast"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 3",
  x: 3,
  y: 18,
  width: 14,
  height: 2,
  rx: 0.7,
  fill: "#717171"
}), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle 1"
}, /*#__PURE__*/React.createElement("mask", {
  id: "path-2-inside-1_1348_21624",
  fill: "white"
}, /*#__PURE__*/React.createElement("rect", {
  x: 4.5,
  width: 11,
  height: 19,
  rx: 1
})), /*#__PURE__*/React.createElement("rect", {
  x: 4.5,
  width: 11,
  height: 19,
  rx: 1,
  stroke: "#717171",
  strokeWidth: 4,
  mask: "url(#path-2-inside-1_1348_21624)"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle 4",
  x: 5,
  y: 12,
  width: 10,
  height: 8,
  rx: 1,
  fill: "#717171"
}));

var SvgCast = function SvgCast(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCast, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cast.fb2db8dd.svg";
export { ForwardRef as ReactComponent };